import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { ZoneService } from '../proxy/planning/controllers/zone.service';
import { StrategicCommercialZoneService } from '../proxy/planning/controllers/strategic-commercial-zone.service';
import { LocationService } from '../proxy/planning/controllers/location.service';
import { VendorService } from '@controlling/proxy/controlling/controllers/vendor.service';
import { InternalOrderService } from '@controlling/proxy/controlling/controllers/internal-order.service';
import { TransportAccessTypeService } from '@woodsupply/proxy/wood-supply/controllers/transport-access-type.service';
import { SeasonTypeService } from '@woodsupply/proxy/wood-supply/controllers/season-type.service';
import { MillService } from '../proxy/planning/controllers/mill.service';
import { PropertyNurseryVendor } from '@controlling/property-nursery-vendor/property-nursery-vendor';

FieldBuilder.setNamespace('Planning');

export const PROPERTY_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Property.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('propertyCode', 'Entity.Property.PropertyCode')
    .minLength(1)
    .maxLength(4)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('internalOrderId', 'Entity.Property.InternalOrder', InternalOrderService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .number('fomentContractId', 'Entity.Property.FomentContract')
    .min(1)
    .build(),
  FieldBuilder
    .number('commercialAgentId', 'Entity.Property.CommercialAgent')
    .build(),
  FieldBuilder
    .text('remsoft', 'Entity.Property.RemSoft')
    .maxLength(200)
    .build(),
  FieldBuilder
    .checkbox('isDisabled', 'Entity.Property.IsDisabled')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('transportAccessTypeId', 'Entity.Property.TransportAccessType', TransportAccessTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('seasonTypeId', 'Entity.Property.SeasonType', SeasonTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('zoneId', 'Entity.Zone', ZoneService)
    .required()
    .displayFromNested('zone.name')
    .sortBy('zone.name')
    .build(),
  FieldBuilder
    .foreignKey('millId', 'Entity.Mill', MillService)
    .display('id')
    .keyField('id')
    .build(),
  FieldBuilder
    .foreignKey('strategicCommercialZoneId', 'Entity.StrategicCommercialZone', StrategicCommercialZoneService)
    .displayFromNested('strategicCommercialZone.name')
    .sortBy('strategicCommercialZone.name')
    .build(),
  FieldBuilder
    .foreignKey('locationId', 'Entity.Location', LocationService)
    .required()
    .displayFromNested('location.name')
    .sortBy('location.name')
    .hideInChildForms()
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('vendorId', 'Entity.Vendor', VendorService)
    .required()
    .display('fantasyName')
    .keyField('id')
    .build(),
];

export const PROPERTY_CONFIG = {
  entityName: 'Property',
  localizationKey: 'Planning::Entity.Property',
  permission: 'PlanningLocation.Properties',
  fields: PROPERTY_FIELDS,
   children: [
    {
      entityName: 'PropertyNurseryVendor',
      foreignKeyField: 'propertyLocationId',
      parentValueField: 'locationId',
      localizationKey: 'Controlling::Entity.PropertyNurseryVendor',
      component: PropertyNurseryVendor,
    },
  ],
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Location + MENU_NAME_SUFFIX,
};
